import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isValid } from 'date-fns';
import { useStores } from 'hooks';
import { Datepicker } from 'components';
import { buildDefaultAndTraineeAnswers, QUESTION_TYPES_FROM_API } from '../../QuizHelper';

const DateQuestion = observer(({ currentQuestionData, withCorrection, isReadOnlyQuestion }) => {
  const { dateInput } = QUESTION_TYPES_FROM_API;

  const { quizStore } = useStores();

  const { currentPage } = quizStore;

  const [currentValue, setCurrentValue] = useState(null);

  const buildAnswers = useCallback(() => {
    setCurrentValue(buildDefaultAndTraineeAnswers(currentQuestionData));
  }, [currentQuestionData]);

  useEffect(() => {
    buildAnswers();
  }, [buildAnswers]);

  const handleChangeDate = useCallback((date) => {
    setCurrentValue(date);

    isValid(date)
      ? quizStore.toggleQuestionValidity({ questionType: dateInput, status: true })
      : quizStore.toggleQuestionValidity({ questionType: dateInput, status: false });

    quizStore.setTraineeAnswers(currentPage, currentQuestionData, date);
  }, [currentPage, currentQuestionData, quizStore, dateInput]);

  return (
    <>
      <Datepicker
        autoComplete="off"
        dataCy="dateQuestion"
        disabled={isReadOnlyQuestion}
        label="common.writeDate"
        name="dateQuestion"
        style={{ margin: '15px 0px' }}
        value={currentValue}
        onChange={(date) => handleChangeDate(date)}
      />
    </>
  );
});

export default DateQuestion;

DateQuestion.propTypes = {
  currentQuestionData: PropTypes.shape({}),
  withCorrection: PropTypes.bool.isRequired,
  isReadOnlyQuestion: PropTypes.bool.isRequired
};

DateQuestion.defaultProps = {
  currentQuestionData: {}
};